import moment from 'moment-timezone';

export const getFixedTimestamp = () => {
  return moment.tz('12:00 PM', 'h:mm', moment.tz.guess());
};
